// Extracted from ContactPage.jsx — company contact details (single source of truth).
// Used by the ContactInfoPanel component and anywhere else that needs phone/email/address.

export const contactDetails = {
  phone: {
    display: '+43 7242 932808',
    href: 'tel:+4372429328080',
    hoursDe: 'Mo. - Do. 8:00 - 17:00, Fr. 8:00 - 13:00',
    hoursEn: 'Mon - Thu 8:00 - 17:00, Fri 8:00 - 13:00'
  },
  address: {
    street: 'Stelzhamerstr. 9',
    city: '4600 Wels',
    countryDe: 'Österreich',
    countryEn: 'Austria',
    mapsHref: 'https://maps.app.goo.gl/r6TioCKDChTmtFAKA'
  },
  email: 'office@e-matrix.at',
  supportEmail: 'e-learning@e-matrix.at'
};
